/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Bauweise der Außenwände. StahlHolzfachwerkFV = Stahl-/Holzfachwerk mit feuerhemmender Verkleidung, StahlHolzfachwerkBV = Stahl-/Holzfachwerk mit beliebiger Verkleidung.
 */
export enum Bauweise {

    Massiv = 'Massiv',

    StahlHolzfachwerkFv = 'StahlHolzfachwerkFV',

    StahlHolzfachwerkBv = 'StahlHolzfachwerkBV',

    Holz = 'Holz'
}

